export enum TextSize {
  XS = 'xs',
  SM = 'sm',
  BASE = 'base',
  LG = 'lg',
  XL = 'xl',
  XXL = '2xl',
  XXXL = '3xl',
  XXXXL = '4xl',
  HERO = 'hero',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
}

export enum TextWeight {
  LIGHT = 'light',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
  EXTRABOLD = 'extrabold',
}

export enum TextAlign {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
}

export enum TextTransform {
  NORMAL = 'normal',
  UPPERCASE = 'uppercase',
  LOWERCASE = 'lowercase',
  CAPITALIZE = 'capitalize',
}

export enum TextDecoration {
  NONE = 'none',
  UNDERLINE = 'underline',
  LINE_THROUGH = 'line-through',
}

export enum LetterSpacing {
  TIGHTER = 'tighter',
  TIGHT = 'tight',
  NORMAL = 'normal',
  WIDE = 'wide',
  WIDER = 'wider',
  WIDEST = 'widest',
}

export interface GenericTextProps {
  /** The text content */
  children: React.ReactNode;
  /** HTML element type (p, span, div, etc.) */
  as?: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'label';
  /** Text size from predefined options */
  size?: TextSize;
  mobileSize?: TextSize;
  /** Custom size if predefined options aren't sufficient */
  customSize?: number;
  mobileCustomSize?: number;
  /** Font weight */
  weight?: TextWeight;
  /** Text alignment */
  align?: TextAlign;
  /** Text color */
  color?: string;
  /** Background color */
  backgroundColor?: string;
  /** Line height */
  lineHeight?: number;
  mobileLineHeight?: number;
  /** Text transformation */
  transform?: TextTransform;
  /** Text decoration */
  decoration?: TextDecoration;
  /** Custom width (e.g., 'full', '1/2', '200px') */
  width?: string;
  /** Whether text should take full width */
  isFullWidth?: boolean;
  /** Custom class names */
  className?: string;
  /** Role attribute for accessibility */
  role?: string;
  /** Hover effect class */
  hoverEffect?: string;
  /** Truncate text with ellipsis */
  truncate?: boolean;
  /** Italic text */
  italic?: boolean;
  /** Letter spacing */
  letterSpacing?: LetterSpacing;
  /** Test ID for testing libraries */
  testId?: string;
}
